import gsap from "gsap";
import debounce from "debounce";

const init = () => {
  const marquees = document.querySelectorAll("[data-marquee]");

  for (const marquee of marquees) {
    const inner = marquee.querySelector("[data-marquee-inner]");
    const text = inner.querySelector("[data-marquee-item]");
    const nItems = Math.ceil(marquee.offsetWidth / text.offsetWidth) + 1;

    if (marquee.offsetWidth === 0) {
      continue;
    }

    inner.innerHTML = "";

    for (let i = 0; i < nItems; i++) {
      const item = text.cloneNode(true);
      inner.appendChild(item);
    }

    const items = inner.querySelectorAll("[data-marquee-item]");

    gsap.killTweensOf(items);
    gsap.to(items, {
      x: "-100%",
      duration: 10,
      repeat: -1,
      ease: "none",
    });
  }
};

const marquee = () => {
  init();

  window.onresize = debounce(init, 200);
};

export default marquee;
